import React from 'react';
import { fetchWeatherData } from '../../../../dataFetchers/weatherDataFetcher';
import { connect } from 'react-redux';
import WeatherComponent from './WeatherComponent';
import { getBECompatibleFuelType } from '../../../../helpers/helper';


class WeatherComponentContainer extends React.Component{
    componentDidMount(){
        this.props.fetchWeatherData(this.props.userId, getBECompatibleFuelType(this.props.configs.data.fuelType));
    }

    render(){
        return(
            <React.Fragment>
                {this.props.weatherData !== null ? <WeatherComponent weatherData={this.props.weatherData}/> : ''}
            </React.Fragment>
        )
    }
}

const mapStateToProps = state => {
    return{
        userId : state.userIdentityDetails.userId,
        weatherData: state.weatherDataInformation.data,
        configs : state.configs
    }
}

const mapDispatchToProps = dispatch => {
    return {
        fetchWeatherData : (uuid, measurementType) => dispatch(fetchWeatherData(uuid, measurementType))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WeatherComponentContainer);